.choice {
  display: flex;
  align-items: flex-start;
  gap: var(--hs-spacing-3);
  color: var(--hs-color-text-primary);
  font: var(--hs-type-body);
  cursor: pointer;
}
.disabled {
  color: var(--hs-color-text-tertiary);
  cursor: default;
}
/* Level with the first line of the label, whatever the size of its type. */
.input {
  margin-top: calc((1lh - 18px) / 2);
}
.text {
  min-width: 0;
}
.label {
  display: block;
}
.hint {
  display: block;
  color: var(--hs-color-text-secondary);
  font: var(--hs-type-body-s);
}
